import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function PatientProjectionLoadingStep() {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "projection-loading-heading", "aria-busy": "true", children: [_jsx("h3", { id: "projection-loading-heading", children: t('projection.loading.heading') }), _jsx("p", { role: "status", children: t('projection.loading.body') })] }));
}
//# sourceMappingURL=loading-step.js.map